<script setup lang="ts">
import { ConfirmDialog } from '@loopreturns/sonik/confirmdialog';
import { Toast } from '@loopreturns/sonik/toast';

import AppTopNav from './AppTopNav.vue';
</script>

<template>
  <div class="flex min-h-0 w-full flex-1 flex-col bg-surface-50 dark:bg-surface-950">
    <AppTopNav />
    <!--
      min-h-0 on shell + main is required: flex items default to min-height:auto, which prevents
      flex-1 descendants from getting a bounded height (fill-height BaseCard / DataTable scroll).
    -->
    <main
      class="mx-auto flex min-h-0 w-full max-w-screen-2xl min-w-0 flex-1 flex-col p-4 lg:p-6"
    >
      <slot />
    </main>
    <Toast position="top-right" />
    <ConfirmDialog />
  </div>
</template>
